module.exports = __webpack_public_path__ + "img/05g_Buy_Scene.e8ae503a.jpg";